/**
 * Created by Administrator on 2017/7/2.
 */
export const TOGGLESIDER = 'ToggleSider';
export const LOGINGMODAL = 'LoginModal';
export const LOGINSUBMIT = 'LoginSubmit';
export const LOGINCLOSED = 'LoginClosed';


// WEBPACK FOOTER //
// ./src/Pages/home/actionTypes.js